import { render, staticRenderFns } from "./dateAndInputForm.vue?vue&type=template&id=15870f00"
import script from "./dateAndInputForm.vue?vue&type=script&lang=js"
export * from "./dateAndInputForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports